export enum RoofType {
    LarssenSheetPiling = 1,  // Damwand
    CorrugatedIron = 2, // Golfplaten
    SandwichPanelTrapezium = 3, // Sandwichpanelen
    SandwichPanelCorrugatedIron = 4, // Sandwichpanelen golfplaten
    LarssenSheetPilingAntiCondense = 5 // Damwand anti condens
};